export const compareOrderObjects = async (order: any, reloadedOrder: any) => {
  return new Promise((resolve) => {
    if (
      order?.VersionNumber === null ||
      reloadedOrder?.VersionNumber === null
    ) {
      resolve({ reload: false, order: null, messages: null });
    } else {
      const hasChanged = order?.VersionNumber < reloadedOrder?.VersionNumber;
      const data = hasChanged ? reloadedOrder : order;
      const messages = [];
      if (hasChanged) {
        // check status
        if (reloadedOrder.Status !== order.Status) {
          const eventType = reloadedOrder.Status?.toLowerCase().includes('fail')
            ? 'error'
            : 'info';
          messages.push({
            text: 'Status Updated: ' + reloadedOrder.Status,
            type: eventType,
          });
        }
        // check last event
        if (reloadedOrder.Events && reloadedOrder.Events.length > 0) {
          const event = reloadedOrder.Events[0];
          const eventType = event?.Name?.toLowerCase().includes('fail')
            ? 'warning'
            : 'info';
          let text = 'Event Updated: ';
          text += event?.Name ? event.Name : '';
          text += event?.Signer ? ' - ' + event.Signer : '';
          messages.push({ text: text, type: eventType });
        }
      }

      resolve({ reload: hasChanged, order: data, messages: messages });
    }
  });
};
